
import { BaseApi } from '@/api/BaseApi'
import Config from '@/const/Config'
import { GetOshiraseListRes } from '@/types/Oshirase'

export class OshiraseApi extends BaseApi {

  public async getOshiraseList(): Promise<GetOshiraseListRes> {
    try {
      const res = await this.post<GetOshiraseListRes>(Config.API_URL + '/oshirase/list', null)
      return res.data
    } catch (e: unknown) {
      throw e
    }
  }

  public async getOshiraseSummary(): Promise<GetOshiraseListRes> {
    try {
      const res = await this.post<GetOshiraseListRes>(Config.API_URL + '/oshirase/summary', null)
      return res.data;
    } catch (e: unknown) {
      throw e;
    }
  }

  public async updateToRead(oshirase_id: number): Promise<void> {
    try {
      const res = await this.post(Config.API_URL + '/oshirase/read', { oshirase_id: oshirase_id })
    } catch (e: unknown) {
      throw e
    }
  }
}
